import React from 'react';
import {Button} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {ISharedWithUser, IUser, Recipient} from '../../../../../../models';
import Avatar from '../../../../../image/Avatar';
import {fullName} from '../../../../../../utils/user';
import {getUserPermission} from './utils';

import SelectAction from '../SelectAction';
import {userIsType} from '../../../../../../utils/auth';

interface ListUsersProps {
  currentUser: IUser | null | undefined;
  recipients: Recipient[];
  selected: ISharedWithUser[];
  createdBy: Partial<IUser>;
  onRemove: (uid: string) => void;
  onChangeAction: (uid: string, action: string) => void;
}

const ListUsers = ({
  currentUser,
  recipients,
  selected,
  createdBy,
  onRemove,
  onChangeAction,
}: ListUsersProps) => {
  const selectedUid = selected.map((s: ISharedWithUser) => s.uid);
  const selectedUsers = recipients.filter((u: Recipient) => selectedUid.includes(u.uid));

  return (
    <div className="list-users">
      {
        selectedUsers.map((user: Recipient) => {
          const firstName = user.first_name || '';
          const lastName = user.last_name || '';
          const userSharingSettings = selected.find((s: ISharedWithUser) => s.uid === user.uid);
          const action = getUserPermission(userSharingSettings);
          const disabled = (user.uid === createdBy.uid as string) || (user.uid === currentUser?.uid);
          const userRole = ""; // we can't get the user's role from `recipients`. TODO userIsType(user);

          return (
            <div
              className="list-users__item"
              key={user.uid}
            >
              <div className="list-users__item__details">
                <Avatar
                  rounded={true}
                  inline={false}
                  names={[firstName, lastName]}
                  image={user.avatar}
                />
                <div
                  className="username bp4-text-overflow-ellipsis"
                >{fullName(user) || user.email}</div>
              </div>
              <div className="list-users__item__actions">
                <SelectAction
                  selected={action}
                  onChange={(action: any) => onChangeAction(user.uid, action.value)}
                  disabled={disabled}
                />
                <Button
                  icon={IconNames.CROSS}
                  minimal={true}
                  onClick={() => onRemove(user.uid)}
                  disabled={disabled}
                />
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ListUsers;
